import { render } from "./ProfileControl.vue?vue&type=template&id=6afbf06f&scoped=true"
import script from "./ProfileControl.vue?vue&type=script&lang=js"
export * from "./ProfileControl.vue?vue&type=script&lang=js"

import "./ProfileControl.vue?vue&type=style&index=0&id=6afbf06f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afbf06f"]])

export default __exports__